module.exports = __webpack_public_path__ + "packs/media/images/home_1-93cf02bd0d409926af99fa57d476ca8e.jpg";